export const appendTo = (self, container_el) => {
  const canvas_el = self._getCanvasElThrowable();
  const view_port = self._getViewPortThrowable();
  container_el.appendChild(canvas_el);
  const { width, height } = container_el.getBoundingClientRect();
  view_port.resize({
    width,
    height,
  });
  self._container_el = container_el;
};
